<template>
  <div class="chart-container">
    <div class="chart-controls">
      <button
        class="year-btn"
        :class="{ active: selectedYear === getThisYearRange[0].substring(0, 4) }"
        @click="selectYear(getThisYearRange)"
      >
        {{ this.getThisYearRange[0].substring(0, 4) }}
      </button>
    </div>
    <div class="chart-controls">
      <button
        v-for="(item, index) in brandsArray"
        :key="index"
        class="brand-btn"
        :class="{ active: selectedBrand === item }"
        @click="selectBrand(item, getThisYearRange)"
      >
        {{ item }}
      </button>
    </div>
    <div class="chart-wrapper">
      <stacked-line-chart
        :chart-data="chartData"
        style="height: 400px; position: relative;"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    "stacked-line-chart": () =>
      import("@/components/common/charts/FinanceLineChart.vue"),
  },
  data() {
    return {
      chartData: {},
      selectedYear: null,
      selectedBrand: null,
      brandsArray: [
        "all",
        "finnik",
        "national_netherlands",
        "cartracker",
        "imoto",
        "traksi",
        "ulubv",
        "ulu",
        "uluuk",
        "fleetify"
      ]

    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    selectYear(range) {
      this.selectedYear = range[0].substring(0, 4);
      this.selectedBrand = null;
      this.fetchData(range);
    },
    selectBrand(brand, range) {
      this.selectedBrand = brand;
      this.fetchBrandData(brand, range);
    },
    fetchData(range) {
      const data = {
        query: `
          query  {
            RevenueArrDetails(
              from: "${range[0]}",
              to: "${range[1]}"
            )
          }
        `
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.chartData = JSON.parse(res.RevenueArrDetails)
        }
      }).finally(() => {
        this.setShowLoadingModal(false);
      })
    },
    fetchBrandData(brand, range) {
      const data = {
        query: `
          query  {
            RevenueArrDetails(
              from: "${range[0]}",
              to: "${range[1]}",
              brand: "${brand}"
            )
          }
        `
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.chartData = JSON.parse(res.RevenueArrDetails)
        }
      }).finally(() => {
        this.setShowLoadingModal(false);
      })
    }
  },
  computed: {
    ...mapGetters([
      "getThisYearRange",
      "getUserSystem"
    ])
  },
  watch: {
    getUserSystem: function() {
      this.selectedYear = this.getThisYearRange[0].substring(0, 4);
      this.selectedBrand = null;
      this.fetchData(this.getThisYearRange);
    }
  },
  mounted() {
    this.selectedYear = this.getThisYearRange[0].substring(0, 4);
    this.fetchData(this.getThisYearRange);
  }
};
</script>

<style scoped>
.chart-container {
  padding: 0;
}

.chart-controls {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  background: white;
  padding: 4px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: fit-content;
}

.year-btn,
.brand-btn {
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.year-btn:hover,
.brand-btn:hover {
  background-color: #edf2f7;
}

.year-btn.active,
.brand-btn.active {
  background-color: #5469d4;
  color: white;
}

.chart-wrapper {
  margin-top: 16px;
}
</style>
